module.exports = __webpack_public_path__ + "static/img/play.2b2248b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/play.png
// module id = RBJf
// module chunks = 1